import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=41f523c6&scoped=true"
import script from "./contents.vue?vue&type=script&lang=ts"
export * from "./contents.vue?vue&type=script&lang=ts"
import style0 from "./contents.vue?vue&type=style&index=0&id=41f523c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f523c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentItem: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/content/Item.vue').default})
